module.exports = __webpack_public_path__ + "media/images/logo-acbe04d3d38f9e2125a3d1f5f5a9eaca.svg";